import { render, staticRenderFns } from "./SnackbarSuccessConfirmation.vue?vue&type=template&id=08a1637a&"
import script from "./SnackbarSuccessConfirmation.vue?vue&type=script&lang=js&"
export * from "./SnackbarSuccessConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports